import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactTable from 'react-table'
import { FormattedMessage } from 'react-intl'
import IPropTypes from 'react-immutable-proptypes'

import { LOCALE_PREFIX } from './constants'

import TextCell from './components/TextCell'
import ReasonCell from './components/ReasonCell'
import CountryCell from './components/CountryCell'

import './style.scss'

export default class ImportResultsTable extends Component {
    static propTypes = {
        duplicated: PropTypes.number.isRequired,
        exists: PropTypes.number.isRequired,
        importResults: IPropTypes.list.isRequired,
        notFound: PropTypes.number.isRequired,
        ok: PropTypes.number.isRequired,
        total: PropTypes.number.isRequired,
    }

    getColumns = () => [
        {
            Header: () => <FormattedMessage id={`${LOCALE_PREFIX}.reason`} />,
            accessor: 'reason',
            Cell: ({ value: reason }) => <ReasonCell reason={reason} />,
        },
        {
            Header: () => <FormattedMessage id={`${LOCALE_PREFIX}.regNbr`} />,
            accessor: 'regNbr',
            Cell: ({ value: regNbr }) => <TextCell text={regNbr} />,
        },
        {
            Header: () => <FormattedMessage id={`${LOCALE_PREFIX}.name`} />,
            accessor: 'name',
            Cell: ({ value: name }) => <TextCell text={name || ' - '} />,
        },
        {
            Header: () => <FormattedMessage id={`${LOCALE_PREFIX}.country`} />,
            accessor: 'country',
            Cell: ({ value: country }) => <CountryCell country={country || 'cs'} />,
        },
    ]

    render() {
        const { duplicated, exists, notFound, ok, total, importResults } = this.props

        return (
            <div className={'import-results-table-wrap'}>
                <div className={'import-results-table-title'}>
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.resultMessage`}
                        values={{
                            duplicated,
                            exists,
                            notFound,
                            ok,
                            total,
                            b: (chunks) => <b>{chunks}</b>,
                            br: <br />,
                        }}
                    />
                </div>

                {importResults.count() > 0 && (
                    <ReactTable
                        data={importResults.toArray()}
                        columns={this.getColumns()}
                        showPagination={false}
                        pageSize={10}
                        manual
                    />
                )}
            </div>
        )
    }
}
